import { normalizeTaxType } from './nonRxTax';

export const getNonRxAuthToken = () => {
  try {
    const user = JSON.parse(sessionStorage.getItem('user') || 'null');
    return user &&
      user.signInUserSession &&
      user.signInUserSession.idToken &&
      user.signInUserSession.idToken.jwtToken
      ? user.signInUserSession.idToken.jwtToken
      : '';
  } catch (error) {
    return '';
  }
};

export const getNonRxAccountIdFromSession = () => {
  const parentAccountId = sessionStorage.getItem('parentAccountId');
  if (![undefined, 'undefined', null, 'null', ''].includes(parentAccountId)) {
    return parentAccountId;
  }
  return '';
};

const parseTaxableFlag = (item) => {
  if (!item) {
    return false;
  }
  if (
    item.is_taxable === true ||
    item.is_taxable === 'true' ||
    item.is_taxable === 1 ||
    item.is_taxable === '1'
  ) {
    return true;
  }
  const taxAmount = parseFloat(item.tax_amount);
  return !Number.isNaN(taxAmount) && taxAmount > 0;
};

export const validateNonRxProductForCatalogSave = (item) => {
  const errors = [];
  const upc = String(item && item.upc ? item.upc : '')
    .replace(/\s+/g, '')
    .trim();
  const itemNumber = String(item && item.item_number ? item.item_number : '').trim();
  const description = String(
    item && item.description ? item.description : ''
  ).trim();

  if (!upc) {
    errors.push('upc');
  }
  if (!itemNumber) {
    errors.push('item_number');
  }
  if (!description) {
    errors.push('description');
  }
  return errors;
};

export const saveNonRxProductWithImage = async ({
  item,
  accountId,
  imageFile,
  token,
}) => {
  if (!token) {
    throw new Error('Not authenticated.');
  }
  if (!accountId) {
    throw new Error('Account is required.');
  }
  if (!imageFile) {
    throw new Error('Image file is required.');
  }
  if (!item) {
    throw new Error('Product is required.');
  }

  const isEdit = !!(item.non_rx_product_id);
  if (!isEdit) {
    const missing = validateNonRxProductForCatalogSave(item);
    if (missing.length > 0) {
      throw new Error('MISSING_REQUIRED_FIELDS');
    }
  }

  const isTaxable = parseTaxableFlag(item);
  const data = new FormData();
  data.append('account_id', accountId);
  data.append('upc', String(item.upc || '').replace(/\s+/g, '').trim());
  data.append('item_number', String(item.item_number || '').trim());
  data.append('description', String(item.description || '').trim());
  data.append(
    'sell_price',
    item.price === 0 || item.price ? item.price : 0
  );
  data.append('uom', item.uom || 'EA');
  data.append('is_taxable', isTaxable ? 'true' : 'false');
  data.append(
    'tax_type',
    isTaxable ? normalizeTaxType(item.tax_type) : 'amount'
  );
  data.append('tax_amount', isTaxable ? item.tax_amount || 0 : 0);
  data.append('status', 'active');

  if (isEdit) {
    data.append('id', item.non_rx_product_id);
    if (item.image_url) {
      data.append('image_url', item.image_url);
    }
  }

  data.append('file', imageFile);

  const response = await fetch(
    `${process.env.REACT_APP_BASEURL}api/non-rx-products/${
      isEdit ? 'update' : 'save'
    }`,
    {
      method: isEdit ? 'PUT' : 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: data,
    }
  );

  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(result.message || 'Failed to save product.');
  }
  return result;
};



// WEBPACK FOOTER //
// ./src/utils/nonRxProductApi.js